import { render } from "./PlanO.vue?vue&type=template&id=854cbb16"
import script from "./PlanO.vue?vue&type=script&lang=js"
export * from "./PlanO.vue?vue&type=script&lang=js"

import "./PlanO.vue?vue&type=style&index=0&id=854cbb16&lang=scss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__